import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { of } from 'rxjs';
import { defaultTrackBySetter, ISimpleListConfig } from './interfaces/isimple-list-config.interface';
import { TemplateFunctionPipe } from '../../pipes/template-function.pipe';
import { FilterPipe } from '../../pipes/filter.pipe';
import { RouterLink } from '@angular/router';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { NHASearchBoxComponent } from '../search-box/search-box.component';
import { NHATestDirective } from '../../directives/test/test.directive';
import { CommonModule } from '@angular/common';

@Component({
	selector: 'nha-simple-list',
	templateUrl: './simple-list.component.html',
	styleUrls: ['./simple-list.component.scss'],
	encapsulation: ViewEncapsulation.None,
	imports: [CommonModule, NHATestDirective, NHASearchBoxComponent, ScrollingModule, RouterLink, FilterPipe, TemplateFunctionPipe]
})
export class NHASimpleListComponent implements OnInit {
	@Input() dense: boolean = false; //TODO: replace with config property
	@Input() config: ISimpleListConfig;
	@Input() items: unknown[] = [];

	@Output() searchTermChanged: EventEmitter<string> = new EventEmitter<string>();
	term: string = '';

	filterMethod = (item: unknown): boolean => {
		if (!this.items?.length || this.term.length < 1) {
			return true;
		}
		if (!this.config?.searchFunc) {
			return true;
		}

		return this.config.searchFunc(item, this.term);
	};

	constructor() {}

	ngOnInit(): void {
		if (!this.config) {
			return;
		}

		if (this.config.placeholder === undefined) {
			this.config.placeholder = 'Search';
		}

		if (this.config.linkTarget === undefined) {
			this.config.linkTarget = '_self';
		}

		if (this.config.linkIsExternal === undefined) {
			this.config.linkIsExternal = () => false;
		}

		if (this.config.displaySearchBarCount === undefined) {
			this.config.displaySearchBarCount = 10;
		}

		if (this.config.itemPadLeft === undefined) {
			this.config.itemPadLeft = '30px';
		}

		if (this.config.searchFunc === undefined) {
			this.config.searchFunc = (item: unknown, term: string) => {
				return JSON.stringify(item).includes(term);
			};
		}

		if (this.config.isSelected$ === undefined) {
			this.config.isSelected$ = () => of(false);
		}

		if (!this.config.trackBy) {
			this.config.trackBy = defaultTrackBySetter;
		}
	}

	onSearchTermChange(searchTerm: string): void {
		this.term = searchTerm;
		this.searchTermChanged.emit(searchTerm);
	}

	onItemClick(item: unknown): void {
		if (this.config?.action !== undefined) {
			this.config.action(item);
		}
	}
}
